import { hasBrandEngineFeature } from 'helpers/featureFlags/hasBrandEngineFeature';
import { getBetaFeatureFlags } from 'bento-ordering/account/reducers';

export const getBrandStyles = state => state.brand.styles;
export const getBrandFonts = state => state.brand.fonts;
export const getBrandLogos = state => state.brand.logos;

export const selectBrandLogo = state => {
  const betaFeatureFlags = getBetaFeatureFlags(state);
  let logo;
  if (hasBrandEngineFeature(betaFeatureFlags)) {
    logo = getBrandLogos(state)?.[0]?.url;
  } else {
    logo = state.account.online_ordering_general_settings?.logo?.[0]?.url;
  }
  return logo ?? state.account.logo;
};
